import { JSX } from 'react';
import { formatToCurrency } from '@betgames/bg-tools';
import { t, partnerSettingsStore, ISkywardGameId } from '@bg-shared';
import classes from './Content.module.scss';

interface IProps {
    gameId?: ISkywardGameId;
}

export const Content = (props: IProps): JSX.Element => {
    const { partnerCurrency } = partnerSettingsStore;
    const limitsSettings = partnerSettingsStore.getBetLimits(props.gameId);

    if (!limitsSettings) {
        return null;
    }

    const renderRow = (text: string, limit: number): JSX.Element => (
        <div className={classes.row}>
            <span>{text}</span>
            <span className={classes.label}>
                {formatToCurrency(limit, partnerCurrency.precision, partnerCurrency.template)}
            </span>
        </div>
    );

    return (
        <>
            {renderRow(t.string('minimum_bet'), limitsSettings.betMin)}
            {renderRow(t.string('maximum_bet'), limitsSettings.betMax)}
            {renderRow(t.string('maximum_win_for_one_bet'), limitsSettings.maxWinPerOneBet)}
        </>
    );
};
